/* eslint-disable react/button-has-type */
import { Icon } from 'assets/index'
import {
  DefaultButton,
  InfoCard,
  Loading,
  MaskedInput2,
  Select2,
} from 'components/index'
import { Form } from '@unform/web'
import { useFetch } from 'hooks'
import { useRef, useState, useContext, useEffect } from 'react'
import { UserContext } from 'context'
import { maskCpfCnpj } from 'helper/utils'
import { Container, Erro } from './style'
import { formatExtract, validateData } from './factory'
import TransactionTable from '../TransactionTable'
import { fakeHistory } from './mock'

interface TransferProps {
  enterprise: {
    name?: string
    id?: string
  }
}

export default function Transferir(props: TransferProps) {
  const { enterprise } = props

  const [transferValue, setTransferValue] = useState('')
  const [pixKey, setPixKey] = useState('')
  const [loading, setLoading] = useState<boolean>(false)
  const { setResumo, setPage } = useContext(UserContext)
  const [pixType, setPixType] = useState<any>('')
  const [pixMask, setPixMask] = useState<string>('')
  const [tableData, setTableData] = useState<Array<any>>([])
  const formRef = useRef<HTMLFormElement | any>(null)
  const api = useFetch()
  const pixSelectOptions = [
    { value: 'CPF', label: 'CPF' },
    { value: 'CNPJ', label: 'CNPJ' },
    { value: 'PHONE', label: 'Telefone' },
    { value: 'EMAIL', label: 'E-mail' },
    { value: 'EVP', label: 'Aleatória' },
  ]

  useEffect(() => {
    // ***********************************************
    // BUSCAR DADOS DA TABELA DE EXTRATO
    // ***********************************************
    api
      .fetch(
        'get',
        null,
        `/gestor/enterprise/${enterprise.id}/extract?type=DEBIT`
      )
      .then((res) => {
        if (!res.data || !res.data.data) {
          return
        }
        const formattedData = formatExtract(res.data.data)
        setTableData(formattedData)
      })
      .catch((err) => {
        console.error('Extract API error:', err)
      })
    // ***********************************************
  }, [])

  const handleGetData = async () => {
    formRef.current.setErrors({})
    const validation = validateData({ transferValue, pixKey, pixType })
    if (validation) return formRef.current.setErrors(validation)
    setLoading(true)

    // ***********************************************
    // BUSCAR INFORMACOES DA TRANSACAO
    // esse endpoint faz uma busca das informacoes ligadas a chave pix selecionada
    // para preencher a pagina de resumo
    // ***********************************************
    try {
      const response: any = await api.fetch(
        'get',
        null,
        `/app/verify-pix/${pixKey}`
      )
      setLoading(false)
      if (response.fail)
        return formRef.current.setErrors({ amount: response.errors.message })
      const { data: resData } = response.data

      setResumo({
        pixType,
        pixKey,
        transferValue,
        to: {
          document: maskCpfCnpj(resData?.to?.document),
          name: resData?.to?.name,
          institution: resData?.to?.institution,
        },
        date: new Date(resData?.date),
        tax: resData?.tax,
      })
      setLoading(false)
      setPage(1)
      // ***********************************************
    } catch (err: any) {
      console.error('err', err)
      formRef.current.setErrors({ amount: 'Erro, tente novamente mais tarde' })
      setLoading(false)
    }
  }

  const handlePixTypeChange = (selectedOption: any) => {
    if (selectedOption && selectedOption.value) {
      setPixType(selectedOption.value)
    }
  }
  return (
    <>
      {loading ? (
        <Loading modal />
      ) : (
        <Container>
          <h1 className="transferir-title">
            Transferir no <span>{enterprise.name}</span>
          </h1>

          <Form
            className="transferir-form-container"
            ref={formRef}
            onSubmit={() => handleGetData()}
          >
            <MaskedInput2
              large
              dataTestId="transfer-value"
              hasAsterisk
              type="money"
              handleChange={(e: string) => {
                setTransferValue(e)
              }}
              placeholder="Valor da Transferência"
              name="amount"
              defaultValue={transferValue}
            />
            <div data-testid="pix-type-select-wrapper">
              <Select2
                placeholder="Tipo de chave pix"
                name="pixType"
                hasAsterisk
                large
                dataTestId="pix-type-select"
                value={pixSelectOptions.find(
                  (option) => option.value === pixType
                )}
                options={pixSelectOptions}
                onChange={(selectedOption: any) => {
                  handlePixTypeChange(selectedOption)

                  if (selectedOption.value === 'PHONE') {
                    setPixMask('cellWithInternational')
                  }
                  if (selectedOption.value === 'CPF') {
                    setPixMask('cpf')
                  }
                  if (selectedOption.value === 'CNPJ') {
                    setPixMask('cnpj')
                  }
                  if (
                    selectedOption.value === 'EMAIL' ||
                    selectedOption.value === 'EVP' ||
                    !selectedOption.value
                  ) {
                    setPixMask('')
                  }
                }}
              />
            </div>
            <MaskedInput2
              large
              type={pixMask}
              dataTestId="pix-key"
              handleChange={(e: any) => {
                setPixKey(e.target.value)
              }}
              placeholder="Chave pix"
              hasAsterisk
              name="pix"
              defaultValue={pixKey}
            />

            <DefaultButton
              type="submit"
              data-testid="continue-button"
              $loading={loading}
              big
              height={50}
            >
              Continuar
            </DefaultButton>
          </Form>

          <div className="depositar-table-container">
            <span className="depositar-table-title">Transferências</span>
            <TransactionTable data={tableData} />
          </div>
        </Container>
      )}
      <div />
    </>
  )
}
